import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MyReservesComponent } from './my-reserves.component';
import { PipesModule } from 'app/pipes/pipes.module';
import { RouterModule } from '@angular/router';



 

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PipesModule,
    ReactiveFormsModule,
    RouterModule
  ],
  declarations: [MyReservesComponent]
})
export class MyReservesModule {}
